/* beautiful-react-hooks version: 0.25.5 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _rollupPluginBabelHelpers = require('./_virtual/_rollupPluginBabelHelpers.js');

var react = require('react');

var createHandlerSetter = require('./utils/createHandlerSetter.js');

var useDidMount = function useDidMount(handler) {
  var _createHandlerSetter = createHandlerSetter.default(handler),
      _createHandlerSetter2 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter, 2),
      onMountHandler = _createHandlerSetter2[0],
      setOnMountHandler = _createHandlerSetter2[1];

  react.useEffect(function () {
    if (onMountHandler.current) {
      onMountHandler.current();
    }
  }, []);
  return setOnMountHandler;
};

exports.default = useDidMount;